import { BinderService } from '@/services/api/binder.service';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-floating-total',
    imports: [CommonModule],
    template: `
<div #totalCard class="card flex flex-col gap-4 p-3 shadow-2 round-top-left col-12 lg:col-3 pl-0"
    style="position: fixed; bottom: 0; width: 100%; z-index: 1000; margin-bottom: 0;">
    <div class="flex flex-wrap gap-4">
        <div class="flex flex-col grow basis-0 gap-2">
            <label class="text-2xl font-bold">Contract Balance</label>
            <div class="font-semibold text-xl">{{calcTotals.balance | currency}}</div>
        </div>
    </div>
</div>
    `,
    styles: `
    .round-top-left {
    border-top-left-radius: var(--border-radius) !important;
}
    `
})
export class FloatingTotalComponent {

  constructor(private binderService: BinderService) { }

  get calcTotals() {
    return this.binderService.totalsData();
  }
}
